import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import PlusIcon from '../icons/PlusIcon';
import sizes from './sizes';

const AddButton = ({
  disabled,
  onClick,
  title,
  id,
  className,
  size,
  dataTestId,
}) => (
  <CircleButton
    id={id}
    size={size}
    className={className}
    color="brand"
    disabled={disabled}
    onClick={onClick}
    title={title}
    dataTestId={dataTestId}
  >
    <PlusIcon className="w-6 h-6" />
  </CircleButton>
);

AddButton.propTypes = {
  id: PropTypes.string,
  size: PropTypes.oneOf(Object.values(sizes)),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  testDataId: PropTypes.string,
};

AddButton.defaultProps = {
  size: sizes.normal,
  disabled: false,
  title: '',
  onClick: () => {},
  testDataId: 'add-button',
};

export default AddButton;
